const CsrfContext = React.createContext();

export default CsrfContext;
